import languages from './languages';
import tours from './tours';
import array from './array';
import promise from './promise';

const module = {
    array,
    promise,
    languages,
    tours,
};

export default module;
